import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService, Language } from '../services/language.service';
import { SeoService } from '../services/seo.service';
import { AdSenseBlockComponent } from '../shared/adsense-block/adsense-block.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, AdSenseBlockComponent],
  template: `
    <div class="home-container">
      <div class="lang-selector">
        <button [class.active]="currentLang === 'fr'" (click)="setLang('fr')">FR</button>
        <span>|</span>
        <button [class.active]="currentLang === 'en'" (click)="setLang('en')">EN</button>
      </div>

      <header class="hero">
        <div class="header-content">
          <img src="assets/logo.png" alt="PuzzlePractice Logo" class="brand-logo logo">
          <div class="header-text">
            <h1>{{ t('home_title') }}</h1>
          </div>
        </div>
        <p>{{ t('home_subtitle') }}</p>
      </header>
      
      <div class="game-grid">
        <div class="game-card glass-card" [routerLink]="['/sudoku']">
          <div class="icon-wrapper sudoku">
            <span class="material-symbols-outlined">grid_on</span>
          </div>
          <h2>Mini Sudoku</h2>
          <p>{{ t('sudoku_desc') }}</p>
          <button class="btn-start">{{ t('play_now') }}</button>
        </div>

        <div class="game-card glass-card" [routerLink]="['/queens']">
          <div class="icon-wrapper queens">
            <span class="material-symbols-outlined">crown</span>
          </div>
          <h2>Queens</h2>
          <p>{{ t('queens_desc') }}</p>
          <button class="btn-start">{{ t('play_now') }}</button>
        </div>

        <div class="game-card glass-card" [routerLink]="['/tango']">
          <div class="icon-wrapper tango">
            <span class="material-symbols-outlined">wb_twilight</span>
          </div>
          <h2>Tango</h2>
          <p>{{ t('tango_desc') }}</p>
          <button class="btn-start">{{ t('play_now') }}</button>
        </div>
      </div>
      
      <div class="home-ad-container">
        <app-adsense-block [adSlot]="'9526827533'"></app-adsense-block>
      </div>

      <footer class="main-footer">
        <a [routerLink]="['/privacy-policy']">{{ t('privacy_title') }}</a>
        <span class="separator">•</span>
        <a [routerLink]="['/contact']">{{ t('contact_title') }}</a>
      </footer>
    </div>
  `,
  styles: [`
    .main-footer {
        margin-top: 1rem;
        text-align: center;
        padding-bottom: 1rem;
        font-size: 0.9rem;
    }
    .main-footer a {
        color: var(--text-muted);
        text-decoration: none;
        transition: color 0.2s;
    }
    .main-footer a:hover {
        color: var(--text-dark);
        text-decoration: underline;
    }
    .separator {
        margin: 0 0.5rem;
        color: rgba(0,0,0,0.2);
    }
  `]
})
export class HomeComponent {
  constructor(
    private langService: LanguageService,
    private seoService: SeoService
  ) { }

  ngOnInit() {
    this.langService.currentLang$.subscribe(lang => {
      if (lang === 'fr') {
        this.seoService.setPageData({
          title: 'Entraînement aux Jeux LinkedIn - Logic Games (Tango, Queens, Sudoku)',
          description: 'Le site d\'entraînement ultime pour les jeux de logique type LinkedIn (Tango/Sun&Moon, Queens/Star Battle, Sudoku). Grilles gratuites et illimitées pour réussir vos tests.',
          keywords: ['entraînement jeu linkedin', 'jeux de logique', 'tango', 'queens', 'star battle', 'sudoku', 'test recrutement', 'brain training'],
          type: 'website'
        });
      } else {
        this.seoService.setPageData({
          title: 'Training for LinkedIn Games - Logic Puzzles (Tango, Queens, Sudoku)',
          description: 'The ultimate training site for LinkedIn-style logic games (Tango/Sun&Moon, Queens/Star Battle, Sudoku). Free unlimited puzzles to ace your assessments.',
          keywords: ['linkedin games training', 'logic puzzles', 'brain training', 'recruitment test practice', 'daily puzzle', 'tango', 'queens'],
          type: 'website'
        });
      }
    });
  }

  get currentLang(): Language {
    return this.langService.getLanguage();
  }

  setLang(lang: Language) {
    this.langService.setLanguage(lang);
  }

  t(key: string): string {
    return this.langService.translate(key);
  }
}
